import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getProductDetails } from "../../actions/Book.action";
import AddProductForm from "../../components/AddProductForm/AddProductForm";
import Layout from "../../components/Shared/Layout/Layout";

const AddProductPage = ({ edit, data, getProductDetails }) => {
  const { id } = useParams();
  useEffect(() => {
    if (edit) {
      getProductDetails(id);
    }
  }, [edit, id]);

  return (
    <div className="bg_light">
      <Layout title={edit ? (!data ? "Loading..." : data.name) : "Add Product"}>
        {edit && !data && <Spinner animation="border" variant="dark" />}
        {edit === true && data ? (
          <AddProductForm data={data} update={true} />
        ) : (
          <AddProductForm />
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.product.selected_product,
});

export default connect(mapStateToProps, { getProductDetails })(AddProductPage);
